/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ScreenerDocumentErrorMetadata } from './ScreenerDocumentErrorMetadata';
import {
    ScreenerDocumentErrorMetadataFromJSON,
    ScreenerDocumentErrorMetadataFromJSONTyped,
    ScreenerDocumentErrorMetadataToJSON,
    ScreenerDocumentErrorMetadataToJSONTyped,
} from './ScreenerDocumentErrorMetadata';

/**
 * 
 * @export
 * @interface ScreenerDocumentError
 */
export interface ScreenerDocumentError {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    document_id?: string;
    /**
     * 
     */
    error_type: ScreenerDocumentErrorErrorTypeEnum;
    /**
     * 
     */
    metadata?: ScreenerDocumentErrorMetadata;
    /**
     * 
     */
    dismissed_at?: Date;
    /**
     * 
     */
    recovered_at?: string;
    /**
     * 
     */
    created_at?: Date;
    /**
     * 
     */
    updated_at?: Date;
    /**
     * 
     */
    deleted_at?: Date;
}


/**
 * @export
 */
export const ScreenerDocumentErrorErrorTypeEnum = {
    SkippedPackageLimitExceeded: 'SKIPPED_PACKAGE_LIMIT_EXCEEDED',
    DownloadError: 'DOWNLOAD_ERROR',
    DownloadErrorEcl: 'DOWNLOAD_ERROR_ECL',
    DocumentTooLarge: 'DOCUMENT_TOO_LARGE',
    DocumentNotRelevant: 'DOCUMENT_NOT_RELEVANT',
    InvalidDocumentType: 'INVALID_DOCUMENT_TYPE',
    DocumentOutsideReviewWindow: 'DOCUMENT_OUTSIDE_REVIEW_WINDOW',
    ProcessingError: 'PROCESSING_ERROR',
} as const;
export type ScreenerDocumentErrorErrorTypeEnum = typeof ScreenerDocumentErrorErrorTypeEnum[keyof typeof ScreenerDocumentErrorErrorTypeEnum];


/**
 * Check if a given object implements the ScreenerDocumentError interface.
 */
export function instanceOfScreenerDocumentError(value: object): value is ScreenerDocumentError {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('error_type' in value) || value['error_type'] === undefined) return false;
    return true;
}

export function ScreenerDocumentErrorFromJSON(json: any): ScreenerDocumentError {
    return ScreenerDocumentErrorFromJSONTyped(json, false);
}

export function ScreenerDocumentErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScreenerDocumentError {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'document_id': json['document_id'] == null ? undefined : json['document_id'],
        'error_type': json['error_type'],
        'metadata': json['metadata'] == null ? undefined : ScreenerDocumentErrorMetadataFromJSON(json['metadata']),
        'dismissed_at': json['dismissed_at'] == null ? undefined : (parseDateTime(json['dismissed_at'])),
        'recovered_at': json['recovered_at'] == null ? undefined : json['recovered_at'],
        'created_at': json['created_at'] == null ? undefined : (parseDateTime(json['created_at'])),
        'updated_at': json['updated_at'] == null ? undefined : (parseDateTime(json['updated_at'])),
        'deleted_at': json['deleted_at'] == null ? undefined : (parseDateTime(json['deleted_at'])),
    };
}

export function ScreenerDocumentErrorToJSON(json: any): ScreenerDocumentError {
    return ScreenerDocumentErrorToJSONTyped(json, false);
}

export function ScreenerDocumentErrorToJSONTyped(value?: ScreenerDocumentError | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'document_id': value['document_id'],
        'error_type': value['error_type'],
        'metadata': ScreenerDocumentErrorMetadataToJSON(value['metadata']),
        'dismissed_at': value['dismissed_at'] == null ? value['dismissed_at'] : serializeDateTime(value['dismissed_at']),
        'recovered_at': value['recovered_at'],
        'created_at': value['created_at'] == null ? value['created_at'] : serializeDateTime(value['created_at']),
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
        'deleted_at': value['deleted_at'] == null ? value['deleted_at'] : serializeDateTime(value['deleted_at']),
    };
}

